import React, { useState, useEffect } from "react";

export default function PolicyConsentModal({ isOpen, onClose }) {
  const [consentItems, setConsentItems] = useState({
    item1: true,
    item2: true,
    item3: false,
    item4: false,
    item5: false,
    item6: false,
  });
  const [confirmAll, setConfirmAll] = useState(false);

  // Load saved consent data when modal opens
  useEffect(() => {
    if (isOpen) {
      const savedConsent = localStorage.getItem("policyConsent");
      if (savedConsent) {
        try {
          const consentData = JSON.parse(savedConsent);
          setConsentItems(consentData.items || consentItems);
          setConfirmAll(consentData.confirmedAll || false);
        } catch (error) {
          console.error("Error loading saved consent:", error);
        }
      }
    }
  }, [isOpen]);

  const handleItemChange = (itemKey) => {
    setConsentItems((prev) => ({
      ...prev,
      [itemKey]: !prev[itemKey],
    }));
  };

  const handleConfirmAllChange = (e) => {
    setConfirmAll(e.target.checked);
  };

  const handleAccept = () => {
  // check 4 option bắt buộc chọn ít nhất 1
  const hasSelectedOptional =
    consentItems.item3 ||
    consentItems.item4 ||
    consentItems.item5 ||
    consentItems.item6;

  if (!hasSelectedOptional) {
    alert("Vui lòng chọn ít nhất 1 mục đích xử lý dữ liệu (mục 3 - 6)");
    return;
  }

  if (!confirmAll) {
    alert("Vui lòng xác nhận đã đọc và đồng ý chính sách");
    return;
  }

  console.log("Consent accepted:", consentItems, confirmAll);

  const consentData = {
    items: consentItems,
    confirmedAll: confirmAll,
    timestamp: new Date().toISOString(),
  };

  localStorage.setItem("policyConsent", JSON.stringify(consentData));
  onClose();
};

  const handleSkip = () => {
    console.log("Consent skipped");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="policy-consent-modal bg-white rounded-lg shadow-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        {/* Close Button */}
        <button
          type="button"
          id="policy-consent-close"
          className="policy-consent-close absolute top-4 right-4 bg-transparent text-gray-600 hover:text-gray-800 text-2xl font-bold w-8 h-8 flex items-center justify-center"
          aria-label="Đóng"
          onClick={onClose}
        >
          ×
        </button>

        <div className="p-6">
          {/* Title */}
          <h3 className="policy-consent-title text-lg font-bold text-center mb-6 text-gray-800">
            XÁC NHẬN SỰ ĐỒNG Ý VỚI MỤC ĐÍCH XỬ LÝ THÔNG TIN KHÁCH HÀNG
          </h3>

          {/* Body Content */}
          <div className="policy-consent-body text-sm text-gray-700 space-y-4">
            <p>
              Bằng việc đánh dấu vào các ô đồng ý trong bảng dưới đây, Khách
              hàng xác nhận đồng ý cho VNPT xử lý thông tin khách hàng cho các
              mục đích như sau:
            </p>

            <p>
              Khách hàng có quyền lựa chọn một, một số hoặc toàn bộ các mục đích
              xử lý thông tin khách hàng đã liệt kê dưới đây.
            </p>

            <ul className="policy-consent-bullets list-disc list-inside space-y-2 text-gray-600">
              <li>
                Mục đích xử lý nêu tại mục 1, 2 là các mục đích không thuộc
                trường hợp phải xin sự đồng ý của Khách hàng theo quy định tại
                điểm b và điểm c, khoản 3 Điều 18 Luật Bảo vệ quyền lợi người
                tiêu dùng năm 2023.
              </li>
              <li>
                Đối với các mục đích xử lý nêu tại mục 3, 4, 5, 6, VNPT chỉ
                thực hiện xử lý dữ liệu khi có sự đồng ý bằng tích chọn của Khách
                hàng.
              </li>
            </ul>

            <p>
              Trường hợp Khách hàng đã đồng ý cho VNPT xử lý dữ liệu mà thay đổi
              ý định và/hoặc muốn từ chối nhận thông tin tiếp thị, giới thiệu
              sản phẩm, quảng cáo và khuyến mại, Khách hàng có thể liên hệ với
              VNPT theo quy định tại Chính sách bảo vệ thông tin khách hàng của
              VNPT.
            </p>

            <p>
              Ngoại trừ các mục đích xử lý dữ liệu nêu trên, nếu cần xử lý dữ
              liệu cá nhân của Khách hàng cho bất kỳ mục đích nào khác, VNPT sẽ
              thông báo cho Khách hàng và chỉ tiến hành xử lý dữ liệu cá nhân
              phù hợp với sự đồng ý của Khách hàng.
            </p>

            <p className="font-semibold">Mục đích xử lý:</p>

            {/* Consent Table */}
            <div className="policy-consent-table overflow-x-auto">
              <table className="w-full border-collapse border border-gray-300">
                <tbody>
                  <tr className="hover:bg-gray-50">
                    <td className="border border-gray-300 p-3 text-gray-700">
                      1. Cung cấp sản phẩm, dịch vụ của VNPT theo yêu cầu của
                      Khách hàng và chỉ trong phạm vi thông tin mà Khách hàng
                      đã đồng ý (không thuộc trường hợp phải xin chấp thuận
                      theo quy định tại điểm b khoản 3 Điều 18 Luật bảo vệ
                      quyền lợi người tiêu dùng 2023).
                    </td>
                    <td className="border border-gray-300 p-3 text-center">
                      <input
                        type="checkbox"
                        checked={consentItems.item1}
                        disabled
                        aria-label="Đồng ý mục 1"
                        className="w-5 h-5 cursor-not-allowed"
                      />
                    </td>
                  </tr>

                  <tr className="hover:bg-gray-50">
                    <td className="border border-gray-300 p-3 text-gray-700">
                      2. Thực hiện các nghĩa vụ theo quy định của pháp luật
                      (không thuộc trường hợp phải xin chấp thuận theo quy định
                      tại điểm c khoản 3 Điều 18 Luật bảo vệ quyền lợi người
                      tiêu dùng 2023).
                    </td>
                    <td className="border border-gray-300 p-3 text-center">
                      <input
                        type="checkbox"
                        checked={consentItems.item2}
                        disabled
                        aria-label="Đồng ý mục 2"
                        className="w-5 h-5 cursor-not-allowed"
                      />
                    </td>
                  </tr>

                  <tr className="hover:bg-gray-50">
                    <td className="border border-gray-300 p-3 text-gray-700">
                      3. Mục đích kinh doanh các dịch vụ xử lý dữ liệu cá nhân
                      (bao gồm nhưng không hạn chế: chấm điểm, xếp hạng tín
                      dụng, đánh giá thông tin tín dụng, đánh giá mức độ tín
                      nhiệm về tín dụng, …), các sản phẩm, dịch vụ dữ liệu; dịch
                      vụ xác thực, dịch vụ định danh (theo quy định tại điểm a
                      khoản 2 Điều 3 Chính sách bảo vệ thông tin khách hàng của
                      VNPT).
                    </td>
                    <td className="border border-gray-300 p-3 text-center">
                      <input
                        type="checkbox"
                        checked={consentItems.item3}
                        onChange={() => handleItemChange("item3")}
                        aria-label="Đồng ý mục 3"
                        className="optional-consent w-5 h-5 cursor-pointer"
                        data-key="3"
                      />
                    </td>
                  </tr>

                  <tr className="hover:bg-gray-50">
                    <td className="border border-gray-300 p-3 text-gray-700">
                      4. Mục đích kinh doanh các dịch vụ quảng cáo, dịch vụ tiếp
                      thị, nghiên cứu thị trường, thăm dò dư luận, môi giới (theo
                      quy định tại điểm b khoản 2 Điều 3 Chính sách bảo vệ
                      thông tin khách hàng của VNPT).
                    </td>
                    <td className="border border-gray-300 p-3 text-center">
                      <input
                        type="checkbox"
                        checked={consentItems.item4}
                        onChange={() => handleItemChange("item4")}
                        aria-label="Đồng ý mục 4"
                        className="optional-consent w-5 h-5 cursor-pointer"
                        data-key="4"
                      />
                    </td>
                  </tr>

                  <tr className="hover:bg-gray-50">
                    <td className="border border-gray-300 p-3 text-gray-700">
                      5. Sử dụng dữ liệu cá nhân của khách hàng để nghiên cứu,
                      phát triển các thuật toán tự học, hệ thống trí tuệ nhân
                      tạo, các hệ thống tự động khác và/hoặc xử lý dữ liệu cá
                      nhân trong công nghệ chuỗi khối, trí tuệ nhân tạo, xử lý
                      dữ liệu lớn để nghiên cứu, phát triển các sản phẩm, dịch
                      vụ hoặc ứng dụng, hệ thống (theo quy định tại điểm c
                      khoản 2 Điều 3 Chính sách bảo vệ thông tin khách hàng của
                      VNPT).
                    </td>
                    <td className="border border-gray-300 p-3 text-center">
                      <input
                        type="checkbox"
                        checked={consentItems.item5}
                        onChange={() => handleItemChange("item5")}
                        aria-label="Đồng ý mục 5"
                        className="optional-consent w-5 h-5 cursor-pointer"
                        data-key="5"
                      />
                    </td>
                  </tr>

                  <tr className="hover:bg-gray-50">
                    <td className="border border-gray-300 p-3 text-gray-700">
                      6. Tổ chức chương trình quảng cáo, giới thiệu sản phẩm,
                      hàng hóa, dịch vụ và thực hiện các hoạt động xúc tiến
                      thương mại đối với sản phẩm, hàng hóa, dịch vụ do VNPT
                      cung cấp cho Khách hàng (theo quy định tại điểm d khoản 2
                      Điều 3 Chính sách bảo vệ thông tin khách hàng của VNPT).
                    </td>
                    <td className="border border-gray-300 p-3 text-center">
                      <input
                        type="checkbox"
                        checked={consentItems.item6}
                        onChange={() => handleItemChange("item6")}
                        aria-label="Đồng ý mục 6"
                        className="optional-consent w-5 h-5 cursor-pointer"
                        data-key="6"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Confirmation Checkbox */}
            <div className="policy-confirm-row border-t border-gray-300 pt-4">
              <label className="flex items-start gap-3 cursor-pointer">
                <input
                  type="checkbox"
                  id="policy-confirm-all"
                  checked={confirmAll}
                  onChange={handleConfirmAllChange}
                  className="w-5 h-5 mt-1 cursor-pointer"
                />
                <span className="text-gray-700">
                  Tôi xác nhận đã đọc, hiểu và đồng ý toàn bộ nội dung của
                  "Chính sách bảo vệ thông tin khách hàng của Tập đoàn Bưu chính
                  Viễn thông Việt Nam".
                </span>
              </label>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="policy-consent-actions flex gap-4 mt-6 justify-end border-t border-gray-300 pt-6">
            <button
              type="button"
              id="policy-consent-skip"
              onClick={handleSkip}
              className="px-6 py-2 bg-gray-300 text-gray-800 rounded-md font-medium hover:bg-gray-400 transition"
            >
              Bỏ qua
            </button>
            <button
              type="button"
              id="policy-consent-accept"
              onClick={handleAccept}
              className="px-6 py-2 bg-blue-600 text-white rounded-md font-medium hover:bg-blue-700 transition disabled:bg-gray-400 disabled:cursor-not-allowed"
              disabled={!confirmAll}
            >
              Đồng ý
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
